// extracted by mini-css-extract-plugin
export default {"title":"EuWcY1"};